import { enumUploadCode } from "../constants";

/**
 * @typedef {Object} UploadFileInfo
 * @property {string} fileName - The uploaded file name
 * @property {string[]} filenames - All uploaded file names in batch
 * @property {string} directory - Target directory path
 * @property {number} [size] - File size in bytes
 */

export function DoUploadStatus() {
  var i = document.getElementById("selectfile");
  if (!i) return;
  if (i["active"] != true) return;
  var fileInfo = {
    fileName: i["curfile"],
    filenames: i["filenames"],
    directory: i["curdir"],
    size: i["size"]
  };
  var doReplace = i["doreplace"];
  i.value = "";
  var dropTarget = i.dropTarget;
  var t = document.getElementById("uploadiframe");
  var callback = t["callback"];
  var result = t.contentWindow.document.body.innerHTML;
  var statusCode = enumUploadCode.success;
  if (doReplace) statusCode = enumUploadCode.successr;
  callback.UploadFileComplete(result, fileInfo, statusCode, dropTarget);
}
